module.exports = __webpack_public_path__ + "static/img/refrigerated-count.c2f1724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/2/refrigerated-count.png
// module id = OQ5r
// module chunks = 1